import ValueX from '../types/ValueX';

export default class PerformedX extends ValueX {
    static __className = 'PerformedX';

    constructor(constructJson) {
        super(constructJson, 'performed', 'PerformedX');
    }
}
